import React from "react";
import { ResponsivePie } from "@nivo/pie";
//
const PieChart = ({ data }) => {
  return (
    <ResponsivePie
      data={data.values}
      colors={data.colors}
      margin={{ top: 50, right: 10, bottom: 180, left: 10 }}
      innerRadius={0.3}
      padAngle={2}
      cornerRadius={5}
      activeOuterRadiusOffset={3}
      borderWidth={1}
      borderColor={{
        from: "color",
        modifiers: [["darker", 0.8]],
      }}
      sortByValue
      // arcLabel={(d) => `${d.id} (${d.value})`}
      enableArcLinkLabels={false}
      arcLinkLabelsSkipAngle={10}
      arcLinkLabelsTextColor="#333333"
      arcLinkLabelsThickness={2}
      arcLinkLabelsColor={{ from: "color" }}
      arcLabelsSkipAngle={10}
      arcLabelsTextColor={{
        from: "color",
        modifiers: [["darker", 2]],
      }}
      defs={[
        {
          id: "linear",
          type: "patternLines",
          background: "inherit",
          color: "rgba(255, 255, 255, 0.3)",
          rotation: -45,
          lineWidth: 6,
          spacing: 10,
        },
        {
          id: "dots",
          type: "patternDots",
          background: "inherit",
          color: "rgba(255, 255, 255, 0.3)",
          rotation: -45,
          lineWidth: 6,
          spacing: 10,
        },
      ]}
      fill={data.fill}
      onClick={(a) => {
        if (data.onClick) {
          data.onClick(a);
        }
      }}
      legends={[
        {
          anchor: "bottom",
          direction: "column",
          justify: false,
          translateX: 0,
          translateY: 110,
          itemsSpacing: 0,
          itemWidth: 80,
          itemHeight: 25,
          itemTextColor: "#999",
          itemDirection: "left-to-right",
          itemOpacity: 1,
          symbolSize: 18,
          symbolShape: "circle",
          effects: [
            {
              on: "hover",
              style: {
                itemTextColor: "#000",
              },
            },
          ],
        },
      ]}
    />
  );
};
export default PieChart;
